import {
  ScheduleDayDto,
  ScheduleDayTypeDto,
  ScheduleDto,
  ScheduleMonthDto,
  ScheduleObservationsDto,
  ScheduleWeekDto
} from '@app/data/dtos/mot/schedule/schedule.dto';
import {
  Schedule,
  ScheduleDay,
  ScheduleDayType,
  ScheduleMonth,
  ScheduleObservations,
  ScheduleWeek
} from '@app/entities/models/mot/schedule/schedule.model';

import { MapFromFn } from '@mercadona/common/public';
import { Builder } from '@mercadona/common/utils';

export const mapSchedule: MapFromFn<ScheduleDto, Schedule> = (value) =>
  Builder.forModel(Schedule)
    .startMonday(value.startMonday)
    .months(value.months.map((month) => mapScheduleMonth(month)))
    .build();

export const mapScheduleDay: MapFromFn<ScheduleDayDto, ScheduleDay> = (value) =>
  Builder.forModel(ScheduleDay)
    .date(value.date)
    .dayLabel(value.dayLabel)
    .dayName(value.dayName)
    .dayType(mapScheduleDayType(value.dayType))
    .hasTasks(value.hasTasks)
    .detail(value.detail)
    .build();

export const mapScheduleDayType: MapFromFn<ScheduleDayTypeDto | null, ScheduleDayType | null> = (value) => {
  if (!value) {
    return null;
  }

  return Builder.forModel(ScheduleDayType)
    .ids(value.ids ?? [])
    .name(value.name ?? '')
    .primaryColour(value.primaryColour ?? '')
    .secondaryColour(value.secondaryColour ?? '')
    .primaryShape(value.primaryShape ?? '')
    .secondaryShape(value.secondaryShape ?? '')
    .isWorkingDay(value.isWorkingDay ?? false)
    .build();
};

export const mapScheduleWeek: MapFromFn<ScheduleWeekDto, ScheduleWeek> = (value) =>
  Builder.forModel(ScheduleWeek)
    .weekLabel(value.weekLabel)
    .weekNumber(value.weekNumber)
    .totalHours(value.totalHours)
    .days(value.days.map((day) => mapScheduleDay(day)))
    .build();

export const mapScheduleMonth: MapFromFn<ScheduleMonthDto, ScheduleMonth> = (value) =>
  Builder.forModel(ScheduleMonth)
    .monthNumber(value.monthNumber)
    .monthLabel(value.monthLabel)
    .yearLabel(value.yearLabel)
    .weeks(value.weeks.map((week) => mapScheduleWeek(week)))
    .build();

export const mapScheduleObservations: MapFromFn<ScheduleObservationsDto, ScheduleObservations> = (value) =>
  Builder.forModel(ScheduleObservations)
    .contract(value.contract)
    .storeInfo(value.storeInfo)
    .monthHours(value.monthHours)
    .monthCaption(value.monthCaption)
    .accumulatedBalance(value.accumulatedBalance)
    .lastModified(value.lastModified)
    .clause(value.clause)
    .rotationGroup(value.rotationGroup)
    .build();
